const styles = theme => ({
  spinnerContainer: {
    marginRight: theme.spacing(2)
  },
  textExplanation: {
    color: theme.palette.primary.default
  },
  cancelButton: {
    color: [theme.palette.primary.default, "!important"]
  },
  disconnectButton: {
    marginLeft: theme.spacing(2),
    backgroundColor: "red",
    "&:hover": {
      backgroundColor: "red"
    }
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/DisconnectIntegrations/styles.js